// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1WU8w","textWrapper":"button-module--text-wrapper--1aA6d","iconWrapper":"button-module--icon-wrapper--2vLzg","light":"button-module--light--2ymK3"};